import React, { Component } from 'react'
import UserRow from '../Users/UserRow.js'
import noImage from '../../images/no_image.png'
import TitleBar from '../TitleBar'
import getLabel from '../../utilities/label.js'
import initializeHelperText from '../../utilities/helperText.js'
import './messages.css'
import _ from 'lodash'

export default class Message extends Component {
  constructor(props) {
    super(props)
    var user = this.getUserFromUserID(props.match.params.id)
    this.markAsRead = this.markAsRead.bind(this)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.state = {
      user: user,
      refreshButton: refreshButton,
      backButton: backButton,
      charsLeft: 6000
    }
    this.refresh = this.refresh.bind(this)
    this.markAsRead = this.markAsRead.bind(this)
    this.props.setActiveTab('homepage', false)
    window.trackPage('MessageDetailScreen', props.match.params.id)
  }

  componentDidMount(){
    this.markAsRead()
    initializeHelperText()
  }

  getImage(user_id) {
    var user = this.getUserFromUserID(user_id)
    if(user.photo) {
      return <img className='rounded-circle' height="80" src={user.photo} alt='' />
    } else {
      return <img height="80" src={noImage} alt='' />
    }
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({
      refreshButton: refreshButton
    })
    this.props.updateResource({
      key: 'messages',
      update: true,
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  getMessages() {
    // {id: 1012, sender_user_id: 490, recipient_user_id: 13, message: "we are migrated!", has_been_read: true, …}
    var messages = []
    var fromImage = this.getImage(this.state.user.user_id)
    var toImage = this.getImage(window.currentUser.user_id)
    _.each(this.props.messages.messages, (message) => {
      if(this.state.user.user_id === message.sender_user_id || this.state.user.user_id === message.recipient_user_id){
        var fromClass = this.state.user.user_id === message.sender_user_id ? 'to-user' : 'from-user'
        messages.push(
          <div key={message.id}>
            <div className={'message-row ' + fromClass}>
              {fromClass === 'to-user' &&
              <div className="row">
              	<div className='col-2'>{fromImage}</div>
              	<div className="message col-8" >{message.message}</div>
              	<div className='col-2'></div>
              </div>
              }
              {fromClass === 'from-user' &&
              <div className="row">
              	<div className='col-2'></div>
              	<div className="message col-8" >{message.message}</div>
              	<div className='col-2'>{toImage}</div>
              </div>
              }
            </div>
          </div>
        )
      }
    })
    return messages
  }

  submit() {
    var data = {
      body: this.state.message,
      recipient_user_id: this.state.user.user_id
    }
    this.props.postResource({ key: 'message', data: data, callback: () => {
      this.setState({ message: '', charsLeft: 6000 })
    }})
  }

  markAsRead() {
    var data = {
      other_user_id: this.state.user.user_id
    }
    this.props.postResource({ key: 'mark_messages_read', data: data, callback: () => {
    }})
  }

  changeMessage(e) {
    this.setState({
      message: e.target.value
    })
    this.characterLimit(e)
  }

  characterLimit(e) {
    this.setState({
      charsLeft: 6000 - e.target.value.length
    })
  }

  getUserFromUserID(user_id) {
    return _.find(this.props.users.event_users, {user_id: parseInt(user_id, 10)})
  }

  getSendButton(){
    return <button className='message-submit-button margin-top-10' onClick={this.submit.bind(this)} >Send</button>
  }

  render() {
    return (
      <div className="message-page">
        <TitleBar
          title={ this.props.pageTitle }
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        <UserRow user={this.state.user} hideIcons={ true } />
        <hr />
        {this.getMessages()}
        <br />
        <div className='message-form'>
          <div className='form-group'>
            <textarea className='form-control' placeholder='Message' 
              value={ this.state.message } 
              onChange={this.changeMessage.bind(this)} 
              maxLength={6000} />
            { this.getSendButton() }
            <p className='chars-left'>{this.state.charsLeft.toLocaleString()} Characters left</p>
          </div>
        </div>
      </div>
    )
  }
}
